import { ArrowLinkCell } from 'components/link/ArrowLink';
import { usePermissions } from 'contexts/PermissionsContext';
import { invalidateUsers } from 'custom_hooks/data_hooks/data_source/usersDataSource';
import { updateUser } from 'utils/user';
import { MultiTextInlineEditor } from './MultiTextInlineEditor';

type NameProps = {
    firstName: string;
    lastName: string;
};
export type UserNameInlineEditorProps = NameProps & {
    userId: string;
    url: string | null;
    onChange?: () => void;
    containerSizing?: 'expand' | 'fit-content';
};

export function UserNameInlineEditor({
    userId,
    firstName,
    lastName,
    url,
    onChange,
    containerSizing,
}: UserNameInlineEditorProps) {
    const { canEditUserProperties } = usePermissions();

    return (
        <MultiTextInlineEditor
            containerSizing={containerSizing}
            template={['firstName', 'lastName'] as const}
            value={{ firstName, lastName }}
            valueClass="ellipsis-1-line"
            onConfirm={async (val) => {
                if (!val?.firstName || !val.lastName) {
                    return;
                }
                await updateUser(userId, {
                    FirstName: val.firstName,
                    LastName: val.lastName,
                });
                invalidateUsers(userId);
                onChange?.();
            }}
            formatInput={(val) => val}
            validate={(val) => {
                if (
                    (val?.firstName && val.firstName.length > 50) ||
                    (val?.lastName && val.lastName.length > 50)
                ) {
                    return 'Maximum 50 characters';
                }
                return undefined;
            }}
            renderValue={(val) =>
                url ? (
                    <ArrowLinkCell
                        title="Select user"
                        className="cursor-pointer text-left mt-5 full-width"
                        to={url}
                    >
                        {val?.firstName ?? '--'} {val?.lastName ?? '--'}
                    </ArrowLinkCell>
                ) : (
                    (val?.firstName ?? '--') + ' ' + (val?.lastName ?? '--')
                )
            }
            isDisabled={!canEditUserProperties}
        />
    );
}
